import { ActionCreator } from 'redux';
import connectActionTypes, { IAction, IConnectedUser } from './types';

export const authenticatedSuccessAction: ActionCreator<IAction> = (user: IConnectedUser) => ({
  type: connectActionTypes.USER_AUTHENTICATION_SUCCESS,
  payload: user,
});

export const authenticatedFailureAction: ActionCreator<IAction> = () => ({
  type: connectActionTypes.USER_AUTHENTICATION_FAILURE,
  payload: {},
});
